import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import ActionDropdown from "./ActionDropdown";
import styles from "./LecturesTable.module.css";

const LecturesTable = ({
	currentLogs,
	formatDate,
	handleEditLecture,
	handleDeleteLecture,
}) => {
	return (
		<div className={styles.tableContainer}>
			<table className={styles.lecturesTable}>
				<thead>
					<tr>
						<th className={styles.dateHeader}>Date</th>
						<th>Period</th>
						<th>Lecture Title</th>
						<th className={styles.sequenceHeader}>Sequence</th>
						<th className={styles.absentHeader}>Absent</th>
						<th className={styles.actionsHeader}>Actions</th>
					</tr>
				</thead>
				<tbody>
					{currentLogs.map((lecture) => (
						<tr key={lecture.id} className={styles.lectureRow}>
							<td className={styles.dateCell}>
								<div className={styles.dateContainer}>
									{formatDate(lecture.date)}
								</div>
							</td>
							<td className={styles.periodCell}>{lecture.period}</td>
							<td className={styles.titleCell}>
								<span className={styles.lectureTitle} title={lecture.title}>
									{lecture.title}
								</span>
							</td>
							<td className={styles.sequenceCell}>
								<div className={styles.sequenceContainer}>
									{lecture.sequence}
								</div>
							</td>
							<td className={styles.absentCell}>
								<div
									className={styles.absentBadge}
									title={lecture.absentStudents.join(", ") || "All present"}
								>
									{lecture.absentStudents.length}
								</div>
							</td>
							<td className={styles.actionsCell}>
								<ActionDropdown
									lecture={lecture}
									onEdit={handleEditLecture}
									onDelete={handleDeleteLecture}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default LecturesTable;
